import { useTheme } from '@adsk/alloy-react-styles';

import { DEFAULT_TABLE_SIZE } from '../consts';
import { TableSize, TableSizeTheme } from '../types';

/**
 * Resolves the density slice (`row-height`, `cell-padding`, `icon-cell-width`)
 * for a given `TableSize` from the active theme. The `getTableTokens*`
 * factories always populate `component.table.size`, so consumers must ship a
 * Weave-aware `@adsk/alloy-react-styles`; there is no static fallback (a theme
 * without the slice would leave the table unstyled regardless).
 *
 * Intentionally package-private — not exported from `./index.ts`. Callers
 * outside this package should drive sizing via the `tableSize` prop, not by
 * importing this hook directly.
 */
const useTableSize = (size: TableSize = DEFAULT_TABLE_SIZE): TableSizeTheme => {
  const theme = useTheme();
  const tokens = theme?.tokens?.component?.table?.size?.[size];

  return {
    size,
    rowHeight: tokens?.rowHeight,
    cellPadding: tokens?.cellPadding,
    iconCellWidth: tokens?.iconCellWidth,
  };
};

export default useTableSize;
